const childRoutes = (prop) => [
    {
        path: 'manpower-management',
        name: prop + '.manpower_management',
        meta: { auth: true },
        component: () => import('../pages/manpower-management/List.vue')
    },
    {
        path: 'procurement-management',
        name: prop + '.procurement_management',
        meta: { auth: true },
        component: () => import('../pages/procurement-management/List.vue')
    },
    {
        path: 'accommodation-info',
        name: prop + '.accommodation_info',
        meta: { auth: true },
        component: () => import('../pages/accommodation-info/List.vue')
    },
    {
        path: 'accommodation-info-view',
        name: prop + '.accommodation_info_view',
        meta: { auth: true },
        component: () => import('../pages/accommodation-info/Details.vue')
    }
]

const routes = [{
    path: '/training-e-learning-service/accommodation-management',
    name: 'training_e_learning_service.accommodation_management',
    component: () => import('@/layouts/TrainingElearningLayout.vue'),
    meta: { auth: true },
    children: childRoutes('training_e_learning_service.accommodation_management')
}]

export default routes
